import type { ReactNode } from 'react';

import { ArrowRight } from '@vaisala/rockhopper-icons/icons/ArrowRight';
import { ChevronRight } from '@vaisala/rockhopper-icons/icons/ChevronRight';
import { Cross } from '@vaisala/rockhopper-icons/icons/Cross';
import { Email } from '@vaisala/rockhopper-icons/icons/Email';
import { LinkNewWindow } from '@vaisala/rockhopper-icons/icons/LinkNewWindow';
import { Logout } from '@vaisala/rockhopper-icons/icons/Logout';
import { Search } from '@vaisala/rockhopper-icons/icons/Search';
import { ShoppingCart } from '@vaisala/rockhopper-icons/icons/ShoppingCart';
import { User } from '@vaisala/rockhopper-icons/icons/User';

/**
 * Icon registry mapping BFF API icon name strings to Rockhopper icon components.
 *
 * Add new entries here as the BFF API introduces additional icon names.
 */
const ICON_MAP: Record<string, ReactNode> = {
  ArrowRight: <ArrowRight />,
  ChevronRight: <ChevronRight />,
  Cross: <Cross />,
  Email: <Email />,
  LinkNewWindow: <LinkNewWindow />,
  Logout: <Logout />,
  Search: <Search />,
  ShoppingCart: <ShoppingCart />,
  User: <User />,
};

/**
 * Resolves a BFF icon name string to a React element.
 * Returns `undefined` if the name is empty or not found in the registry.
 */
export function resolveIcon(iconName?: string): ReactNode | undefined {
  if (!iconName) return undefined;
  return ICON_MAP[iconName];
}
